import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { Card, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import { getAllPromoCodesAsync, deletePromoCodeAsync } from "../redux/promoApi";
import { PromoActions } from "../redux/promoAction";
import PromoCodesTable from "./promo_detail/promoCodesTable";
import AddPromoCode from "./promo_detail/AddPromoCode";
import GeneratePromoCodes from "./promo_detail/GeneratePromoCodes";
import PromoCodeUsageModal from "./promo_detail/PromoCodeUsageModal";
import BasicPagination from "../../pagination/BasicPagination";

export function PromoCodeManagement() {
  const [DeleteModal, setDeleteModal] = useState(false);
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showUsageModal, setShowUsageModal] = useState(false);
  const [selectedPromo, setSelectedPromo] = useState({});
  const [selectedPromoForUsage, setSelectedPromoForUsage] = useState({});
  
  const deleteClose = () => setDeleteModal(false);
  const deleteShow = () => setDeleteModal(true);

  const [selectedID, setSelectedID] = useState();
  const searchRef = useRef();

  const { isLoading, promoLists, refreshPromo, skip, limit, search } = useSelector(
    (state) => state.promoCodeManagement,
    shallowEqual
  );

  const dispatch = useDispatch();

  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(PromoActions.setPromoBatchNumber(count));
  };

  // Load data when pagination or search changes (same as Event Management)
  useEffect(() => {
    dispatch(getAllPromoCodesAsync({ limit, skip, searchText: search }));
  }, [skip, refreshPromo]);

  useEffect(() => {
    if (searchRef.current) {
      let keyPressEvent = (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          dispatch(PromoActions.refreshPromoList());
        }
      };
      let input = searchRef.current;
      input.addEventListener("keyup", keyPressEvent);

      return () => {
        input.removeEventListener("keyup", keyPressEvent);
        dispatch(PromoActions.searchPromoTextChange(""));
        input.value = "";
      };
    }
  }, []);

  const onSearchTextChange = (e) => {
    dispatch(PromoActions.searchPromoTextChange(e.target.value));
  };

  const onDeleteClick = (promo) => {
    setSelectedID(promo);
    deleteShow();
  };

  const onDeactiveClick = () => {
    dispatch(deletePromoCodeAsync(selectedID._id));
    setSelectedID({});
    deleteClose();
  };

  const onSelectPromo = async (promo) => {
    setSelectedPromo(promo);
    setShowPromoModal(true);
  };

  const onViewUsage = (promo) => {
    setSelectedPromoForUsage(promo);
    setShowUsageModal(true);
  };

  return (
    <>
      <Card>
        <CardHeader title="Promo Code Management">
          <CardHeaderToolbar>
            <div className="d-flex flex-wrap ap_filter_wraper justify-content-end align-items-center">
              <form
                autoComplete="off"
                className="subheader_filter"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-row">
                  <div className="form-group mr-3 mb-1">
                    <input
                      name="Search"
                      placeholder="Search. . ."
                      type="text"
                      className="form-control"
                      value={search}
                      onChange={onSearchTextChange}
                      ref={searchRef}
                    />
                  </div>
                </div>
              </form>
              <div className="form-group mr-5 mb-1 mt-2">
                <button className="btn_new btn-sm" type="button" onClick={() => onSelectPromo({})}>
                  Create Manual Promo Codes
                </button>
              </div>
              <div className="form-group mr-5 mb-1 mt-2">
                <button className="btn_new btn-sm" type="button" onClick={() => setShowGenerateModal(true)}>
                  Generate Auto Promo Codes
                </button>
              </div>
            </div>
          </CardHeaderToolbar>
        </CardHeader>
        <PromoCodesTable
          promoLists={promoLists}
          onSelectPromo={onSelectPromo}
          onDeleteClick={onDeleteClick}
          onViewUsage={onViewUsage}
          isLoading={isLoading}
          skip={skip}
          limit={limit}
        />
        <div className="row d-flex align-items-center mr-5 ml-5 mt-4 btm-pagination">
          <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-left">
            Displaying {skip * limit + 1} - {skip * limit + (promoLists?.data?.length || 0)} of{" "}
            {promoLists?.recordsTotal || 0} Records
          </div>
          <div className="col-md-8 text-left mb-5 aspgntn">
            <BasicPagination
              className="justify-content-end"
              totalRecords={promoLists?.recordsTotal || 0}
              limit={limit}
              batch={skip + 1}
              onBatchChange={onPageChange}
            />
          </div>
        </div>
        <AddPromoCode
          setShowPromoModal={setShowPromoModal}
          showPromoModal={showPromoModal}
          selectedPromo={selectedPromo}
          isLoading={isLoading}
        />
        <GeneratePromoCodes
          showGenerateModal={showGenerateModal}
          setShowGenerateModal={setShowGenerateModal}
          isLoading={isLoading}
        />
        <PromoCodeUsageModal
          showUsageModal={showUsageModal}
          setShowUsageModal={setShowUsageModal}
          selectedPromo={selectedPromoForUsage}
        />
      </Card>

      <Modal show={DeleteModal} onHide={deleteClose} centered className="def_modal delete_modal">
        <Modal.Header>
          <Modal.Title className="fn_s_18 color_blk f-w-700">Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form def_form frmwtpddng">
            <p className="fn_s_18 f-w-400 text-center mb-10">Are you sure want to delete ?</p>
            <div className="form-group d-flex flex-wrap justify-content-center align-items-center mb-0">
              <div className="form-group mr-5 mb-1 mt-2">
                <button className="btn_new btn-sm" type="button" onClick={deleteClose}>
                  Close
                </button>
              </div>
              <div className="form-group mr-5 mb-1 mt-2">
                <button className="btn_new btn-sm" type="button" onClick={onDeactiveClick}>
                  Yes, Delete it
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
} 